import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Carriers_ds_get_carrier_associationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { carrier_ids?: number[] }): 
  Promise<{ result: { Id?: number, DockAppointments?: { Id?: number, CreatedSysDateTime?: string }[], Shipments?: { Id?: number, CreatedSysDateTime?: string }[], OrdersForPreferredCarrier?: { Id?: number, CreatedSysDateTime?: string }[], LoadContainerListForCarrier?: { Id?: number, CreatedSysDateTime?: string }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { carrier_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DockAppointments?: { Id?: number, CreatedSysDateTime?: string }[], Shipments?: { Id?: number, CreatedSysDateTime?: string }[], OrdersForPreferredCarrier?: { Id?: number, CreatedSysDateTime?: string }[], LoadContainerListForCarrier?: { Id?: number, CreatedSysDateTime?: string }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { carrier_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, DockAppointments?: { Id?: number, CreatedSysDateTime?: string }[], Shipments?: { Id?: number, CreatedSysDateTime?: string }[], OrdersForPreferredCarrier?: { Id?: number, CreatedSysDateTime?: string }[], LoadContainerListForCarrier?: { Id?: number, CreatedSysDateTime?: string }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      carrier_ids?: number[]    }) {
      return false;
    }
}
